// extracted by mini-css-extract-plugin
export default {"quiz":"quiz_quiz__Seqzz","quiz__desc":"quiz_quiz__desc__b6bK4","quiz__question":"quiz_quiz__question__a9Gve"};